import gql from 'graphql-tag';

export const listDashboards = gql`
  query ListDashboardsQuery {
    listDashboards {
      createdAt
      updatedAt
      id
      businessId
      entityWidgets {
        id
        channelId
        workflowTemplateId
        viewTemplateId
        name
      }
    }
  }
`;

export const listUserEntityWidgets = gql`
  query ListUserEntityWidgets {
    listUserEntityWidgets {
      entityWidgetId
    }
  }
`;
